/* ============================================================
   pop-corporate.js — People of Prints Corporate Gifting Page
   Loaded only for templates/page.corporate-gifting.json
   ============================================================ */

(function () {
  'use strict';

  function init() {
    initOfferingsTabs();
    initCategories();
    initGalleryFilter();
    initCaseStudies();
  }

  /* ── OFFERINGS TABS ─────────────────────────────────────── */
  function initOfferingsTabs() {
    document.querySelectorAll('.cg-offerings').forEach(function (section) {
      var tabs   = section.querySelectorAll('.cg-off-tab');
      var panels = section.querySelectorAll('.cg-off-panel');

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t)   { t.classList.remove('active'); });
          panels.forEach(function (p) { p.classList.remove('active'); });
          tab.classList.add('active');
          if (panels[i]) panels[i].classList.add('active');
        });
      });
    });
  }

  /* ── COLLAPSIBLE CATEGORIES ─────────────────────────────── */
  function initCategories() {
    document.querySelectorAll('.cg-categories').forEach(function (section) {

      /* Card click — toggle panel below that row */
      section.querySelectorAll('.cg-cat-card').forEach(function (card) {
        card.addEventListener('click', function () {
          var idx    = card.dataset.idx;
          var panel  = section.querySelector('.cg-cat-panel[data-panel="' + idx + '"]');
          if (!panel) return;

          var wasOpen = panel.classList.contains('open');

          /* Close everything */
          section.querySelectorAll('.cg-cat-panel').forEach(function (p) { p.classList.remove('open'); });
          section.querySelectorAll('.cg-cat-card').forEach(function (c)  { c.classList.remove('active'); });

          /* Open if it wasn't already open */
          if (!wasOpen) {
            panel.classList.add('open');
            card.classList.add('active');
            /* Smooth scroll so panel is visible */
            setTimeout(function () {
              panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 50);
          }
        });
      });

      /* Close button inside each panel */
      section.querySelectorAll('.cg-cat-panel-close').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var panel = btn.closest('.cg-cat-panel');
          if (panel) panel.classList.remove('open');
          section.querySelectorAll('.cg-cat-card').forEach(function (c) { c.classList.remove('active'); });
        });
      });
    });
  }

  /* ── GALLERY FILTER ─────────────────────────────────────── */
  function initGalleryFilter() {
    document.querySelectorAll('.cg-gallery').forEach(function (section) {
      section.querySelectorAll('.cg-gal-filter').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var cat = tab.dataset.cat;

          section.querySelectorAll('.cg-gal-filter').forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');

          section.querySelectorAll('.cg-gal-item').forEach(function (item) {
            item.style.display = (cat === 'all' || item.dataset.cat === cat) ? '' : 'none';
          });
        });
      });
    });
  }

  /* ── CASE STUDIES ACCORDION ─────────────────────────────── */
  function initCaseStudies() {
    document.querySelectorAll('.cg-case-studies').forEach(function (section) {
      section.querySelectorAll('.cg-cs-head').forEach(function (head) {
        head.addEventListener('click', function () {
          var item    = head.closest('.cg-cs-item');
          var wasOpen = item.classList.contains('open');

          /* Close all */
          section.querySelectorAll('.cg-cs-item').forEach(function (i) { i.classList.remove('open'); });

          /* Re-open if it wasn't already open */
          if (!wasOpen) item.classList.add('open');
        });
      });
    });
  }

  /* ── BOOT ───────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
